export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="inline-block border-2 border-gray-800 rounded-full px-6 py-2 mb-8">
          <span className="text-sm font-semibold text-gray-800 uppercase tracking-wide">About IGANA</span>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-relaxed mb-6">
          We are dedicated to protecting<br />
          your digital privacy with<br />
          innovative security solutions<br />
          and cutting-edge technology
        </h2>

        <div className="flex justify-center gap-8 mt-12">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-shield-check-line text-4xl text-teal-600"></i>
            </div>
            <span className="text-gray-700 font-medium">Secure</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-global-line text-4xl text-teal-600"></i>
            </div>
            <span className="text-gray-700 font-medium">Global</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-speed-line text-4xl text-teal-600"></i>
            </div>
            <span className="text-gray-700 font-medium">Fast</span>
          </div>
        </div>
      </div>
    </section>
  );
}
